import { useRuntimeConfig } from '#imports'
import { type MaybeRefOrGetter, computed, toValue } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { PaymentFlow } from '../config/flows'

/**
 * Knows if the payment flow is available on the payment subdomain for the current user.
 * (based on a feature flag for now, but could be extended to AB tests)
 */
export function useIsPaymentDomainEnabled(flow: MaybeRefOrGetter<PaymentFlow>) {
  const {
    FF_PAYMENT_DOMAIN_BUYBACK_ENABLED_COUNTRIES,
    FF_PAYMENT_DOMAIN_INSURANCE_DUE_AMOUNT_ENABLED_COUNTRIES,
    FF_PAYMENT_DOMAIN_INSURANCE_POST_PURCHASE_ENABLED_COUNTRIES,
  } = useRuntimeConfig().public.payment
  const country = useMarketplace().market.countryCode

  return computed(() => {
    if (toValue(flow) === PaymentFlow.BUYBACK_SELLER_UPDATE_PAYMENT_METHOD) {
      return FF_PAYMENT_DOMAIN_BUYBACK_ENABLED_COUNTRIES.includes(country)
    }

    if (toValue(flow) === PaymentFlow.INSURANCE_DUE_AMOUNT) {
      return FF_PAYMENT_DOMAIN_INSURANCE_DUE_AMOUNT_ENABLED_COUNTRIES.includes(
        country,
      )
    }

    if (toValue(flow) === PaymentFlow.INSURANCE_POST_PURCHASE) {
      return FF_PAYMENT_DOMAIN_INSURANCE_POST_PURCHASE_ENABLED_COUNTRIES.includes(
        country,
      )
    }

    return false
  })
}
